export default "__VITE_ASSET__0a6405f2__"